var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14zm-1.624-14.316v3.41h2.31v-1.936a5.573 5.573 0 001.496-.484 4.898 4.898 0 001.32-.902c.382-.367.69-.807.924-1.32.235-.513.352-1.1.352-1.76 0-.645-.117-1.232-.352-1.76a3.513 3.513 0 00-.968-1.364 4.41 4.41 0 00-1.54-.88c-.586-.205-1.246-.308-1.98-.308-.733 0-1.378.103-1.936.308a4.887 4.887 0 00-1.452.77 4.726 4.726 0 00-1.012 1.144 5.298 5.298 0 00-.594 1.32l2.09.836c.176-.66.499-1.203.968-1.628.47-.44 1.086-.66 1.848-.66.719 0 1.29.176 1.716.528.44.352.66.895.66 1.628v.308c0 .924-.344 1.606-1.034 2.046-.69.425-1.628.66-2.816.704zm-.22 8.118c.279.279.756.418 1.43.418.675 0 1.152-.14 1.43-.418.279-.279.418-.63.418-1.056v-.528c0-.425-.14-.777-.418-1.056-.278-.279-.755-.418-1.43-.418-.674 0-1.151.14-1.43.418-.278.279-.418.63-.418 1.056v.528c0 .425.14.777.418 1.056z"
  })));
}

export default __webpack_public_path__ + "848cf350f86c1649a8d4454425010cad.svg";
export { SvgHelpFilled as ReactComponent };